import React from "react";
import QuestionMark from "../../../assets/Icon/QuestionMark";
import CustomInput from "../../UI/CustomInput";
import cs from "classnames";
import TooltipButton from "../../UI/TooltipButton";
import Dropdown from "../../UI/Dropdown";

const StepFour = ({
  data,
  setData,
  calculatorType,
  handleBlur,
  dataError,
  setDataError,
  handleEnter,
  isStep3,
}) => {
  const isProfileMarginType = calculatorType === "calc-5";

  const handleChange = ({ target: { value, name } }) => {
    if (!value) {
      isProfileMarginType
        ? setDataError({ ...dataError, listingPriceError: true })
        : setDataError({ ...dataError, materialsError: true });
    } else {
      isProfileMarginType
        ? setDataError({ ...dataError, listingPriceError: false })
        : setDataError({ ...dataError, materialsError: false });
    }
    setData({ ...data, [name]: value });
  };

  const handleMarketplacesSelect = ({ value }) => {
    setData({
      ...data,
      marketplaces: value,
    });
  };

  return (
    <div>
      <div className="mt-3 mb-2 product-label">
        {isProfileMarginType
          ? "What is your listing price?"
          : "What is the cost of materials?"}
        <TooltipButton
          title={
            isProfileMarginType
              ? "Ex: You list your homemade candle for $20."
              : "Ex: You spent $3 on candle making materials such as wicks, wax, fragrance oil and a container."
          }
          placement="top"
          icon={<QuestionMark />}
        />
      </div>
      <div className="d-flex align-items-center">
        <span className="font-currency mr-2">$</span>
        <CustomInput
          formControlClass="time-input"
          placeholder="00.00"
          type="number"
          min="0"
          name={isProfileMarginType ? "listingPrice" : "materials"}
          value={isProfileMarginType ? data.listingPrice : data.materials}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyPress={handleEnter}
          autoFocus
          className={cs({
            ["error-input"]:
              dataError.materialsError || dataError.listingPriceError,
          })}
        />
      </div>

      {isProfileMarginType && (
        <div className="mt-4">
          <Dropdown
            label="Select marketplaces "
            onChange={handleMarketplacesSelect}
            value={data.marketplaces}
            disabled={false}
            options={[
              {
                value: "Mercari",
                label: "Mercari",
              },
              {
                value: "Ebay",
                label: "Ebay",
              },
              {
                value: "Amazon",
                label: "Amazon",
              },
            ]}
          />
        </div>
      )}
    </div>
  );
};
export default StepFour;
